/**
 * SOLID Review
 * S — Strong. Renders a full-screen spinner with an optional message. Nothing else.
 * O — Strong. The single `message` prop covers the only variation point; no branching logic to extend.
 * L — N/A — no inheritance hierarchy.
 * I — Strong. One optional prop (`message`).
 * D — Strong. Depends only on `react`.
 */
import React from 'react';

interface LoadingBoundaryProps {
  readonly message?: string;
}

export const LoadingBoundary: React.FC<LoadingBoundaryProps> = ({ message = 'Loading…' }) => (
  <div
    role="status"
    aria-label={message}
    style={{
      position: 'fixed',
      inset: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#0a0a0a',
      gap: 16,
    }}
  >
    <div
      style={{
        width: 48,
        height: 48,
        borderRadius: '50%',
        border: '3px solid #374151',
        borderTopColor: '#10b981',
        animation: 'spin 0.8s linear infinite',
      }}
    />
    <span
      style={{
        color: '#9ca3af',
        fontFamily: 'system-ui, sans-serif',
        fontSize: 14,
      }}
    >
      {message}
    </span>
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);
